import React, { forwardRef, useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import clsx from "clsx";
import { Button, Typography } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { formatCardExpiryDate, formatCreditCardNo, isFunction, convertToOptions } from "@util/utils";
import { ReadTextField } from "@icoach/components";
import { useMemberPaymentApi } from "@apis/useMemberPaymentApi";
import { PAYMENT_TYPE, CREDIT_CARD_TYPE } from "@icoach/constants";

const CREDIT_CARD_TYPE_OPTIONS = convertToOptions(CREDIT_CARD_TYPE);

const paymentFieldsMap = {
	[PAYMENT_TYPE.CREDITCARD]: [
		{
			key: "memberName",
			label: "會員",
		},
		{
			key: "memberNo",
			label: "會員編號",
		},
		{
			key: "creditCardNo",
			label: "信用卡卡號",
			format: v => formatCreditCardNo(v),
		},
		{
			key: "cardExpiryDate",
			label: "到期日",
			format: v => formatCardExpiryDate(v),
		},
		{
			key: "creditCardType",
			label: "卡別",
			format: v => CREDIT_CARD_TYPE_OPTIONS.find(item => item.value === v)?.text || "",
		},
		{
			key: "creditCardBankName",
			label: "發卡銀行",
		},
		{
			key: "cardName",
			label: "持卡人姓名",
		},
		{
			key: "cardRelation",
			label: "信用卡關係為",
		},
	],
	[PAYMENT_TYPE.ACH]: [
		{
			key: "memberName",
			label: "會員",
		},
		{
			key: "bankCode",
			label: "銀行代碼",
		},
		{
			key: "bankName",
			label: "銀行名稱",
		},
		{
			key: "bankAccount",
			label: "銀行帳號",
		},
		{
			key: "bankAccountName",
			label: "銀行帳戶",
		},
		{
			key: "bankAccountID",
			label: "帳戶身分證字號",
		},
	],
};

const ViewPaymentDialog = forwardRef(({ open, sourceData, refresh, onClose }, ref) => {
	if (!open) return null;

	const { title, onEdit } = sourceData || {};
	const { getMemberPaymentApi } = useMemberPaymentApi();
	const [memberPayment, setMemberPayment] = useState({});

	const doGetMemberPaymentApi = async ({ memberID, memberPaymentID }) => {
		let resp = await getMemberPaymentApi({ memberID, paymentID: memberPaymentID });

		if (resp) {
			setMemberPayment(resp);
		}
	};

	useEffect(
		() => {
			if (open) {
				doGetMemberPaymentApi(sourceData);
			}
		},
		// eslint-disable-next-line
		[open]
	);

	return (
		<Dialog className={clsx("simple-content", "dialog", "payment-dialog")} PaperProps={{ className: "wx-70rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>查看會員付款資訊</GradientColorHeader>
			<DialogContent>
				<Typography className={"font-weight-bold"} variant={"h6"}>
					{title}
				</Typography>
				<Grid spacing={2} container>
					{paymentFieldsMap[memberPayment?.paymentType || PAYMENT_TYPE.CREDITCARD]?.map(({ key, label, format }) => (
						<Grid xs={6} item key={key}>
							<ReadTextField key={key} label={label}>
								{isFunction(format) ? format(memberPayment[key]) : memberPayment[key]}
							</ReadTextField>
						</Grid>
					))}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={onEdit}>
					進行編輯
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default ViewPaymentDialog;
